import { dayOf } from './iso-day'

const dateFormat = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

export function formatDate(
  date: Date | string | number | null | undefined,
  fallback = '-',
): string {
  if (!date) return fallback
  // A bare ISO day is a calendar day, not UTC midnight: read as a moment it
  // would be the day before west of Greenwich.
  const day = typeof date === 'string' ? dayOf(date) : null
  if (day) return dateFormat.format(new Date(day.year, day.month - 1, day.day))
  // A millisecond epoch is accepted too: logs and queue jobs carry one.
  const d = date instanceof Date ? date : new Date(date)
  return dateFormat.format(d)
}

const timeFormat = new Intl.DateTimeFormat('de-DE', {
  hour: '2-digit',
  minute: '2-digit',
})

export function formatTime(
  date: Date | string | number | null | undefined,
  fallback = '-',
): string {
  if (!date) return fallback
  // A millisecond epoch is accepted too: logs and queue jobs carry one.
  const d = date instanceof Date ? date : new Date(date)
  return timeFormat.format(d)
}

const dateTimeFormat = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
})

/**
 * Format an ISO timestamp with a "today" shortcut.
 * Returns "Heute, 14:30" or "18.03.2026, 14:30".
 */
export function formatTimestampWithToday(
  iso: string | null,
  todayLabel: string,
): string {
  if (!iso) return '-'
  const date = new Date(iso)
  const now = new Date()
  const isToday =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear()
  const time = formatTime(date)
  return isToday ? `${todayLabel}, ${time}` : `${formatDate(date)}, ${time}`
}

/** A millisecond epoch is accepted too: logs and queue jobs carry one. */
export function formatDateTime(
  date: Date | string | number | null | undefined,
  fallback = '-',
): string {
  if (!date) return fallback
  const d = date instanceof Date ? date : new Date(date)
  return dateTimeFormat.format(d).replace(', ', ' ')
}
